<app-breadcrumb [master]="'Terminale'" [parentName]="'Polisy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-terminals-details-view *ngIf="!modify" [terminals]="terminals" (modifyClickedEdit)="modify = true"  (modifyClicked)=" loadSupport()"></app-terminals-details-view>
    <app-terminals-details-form *ngIf="modify" [terminalsObject]="terminalsObject"
                                   (closeModification)="modify = false; loadSupport()"></app-terminals-details-form>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [terminals]="terminals"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
